"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipLinkContainer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _layout = require("../../layout");
function shouldForwardProp(propName) {
  switch (propName) {
    case "isFocused":
    case "theme":
      return false;
  }
  return true;
}
const SkipLinkContainer = (0, _styled.default)(_layout.Spacer, {
  shouldForwardProp
})(_ref => {
  let {
    theme,
    isFocused
  } = _ref;
  return `
    background: ${theme.skipLink.container.bg};
    padding: ${_spacing.sizes.xxSmall}px;
    box-shadow: ${theme.skipLink.container.boxShadow};
    border-radius: ${theme.skipLink.container.borderRadius};
    font-weight: 500;
    padding: ${theme.skipLink.container.padding};
    height: ${theme.skipLink.container.height};

    // since it's position: absolute, ensure it has its own stacking context.
    z-index: 1;
    position: absolute;
    top: ${theme.skipLink.container.top};
    left: 50%;

    display: flex;
    align-items: center;

    opacity: ${isFocused ? "1" : "0"};
    transform: ${isFocused ? "translateX(-50%) translateY(0%)" : "translateX(-50%) translateY(-500%)"};
`;
});
exports.SkipLinkContainer = SkipLinkContainer;
//# sourceMappingURL=SkipLinkContainer.js.map